<rt-collapsible-card
  rtCollapsibleCardAnalytics
  analyticsKey="talentPools"
  uniqKey="candidate-talent-pools"
>
  <div leftSlot layout layout-align-items-center>
    <rt-heading>
      {{ 'app.candidate.talent_pools' | translate }}
    </rt-heading>
    <rt-collapsed-card-child>
      <rt-badge margin-left-small-xx [text]="placements().length" color="counter-default" />
    </rt-collapsed-card-child>
  </div>
  <div collapsible layout-full-width padding-lr padding-bottom-small-x>
    @for (placement of placements(); track placement.id) {
      <div layout-horizontal layout-align-items-center layout-space-between>
        <a
          [routerLink]="'talent_pools/' + placement.talentPool!.slug + '/filters'"
          class="talent-pool-link"
          rtTooltip
          [rtTooltipTemplate]="offerTitleTooltipTemplate"
          rtTooltipPosition="leftbelow"
          rtTooltipType="light"
          [rtTooltipMaxWidth]="320"
          [rtTooltipHasShadow]="true"
          [rtTooltipHasBorder]="true"
          [rtTooltipArrowPush]="true"
        >
          <rt-icon
            name="nav-talent-pools-outline"
            size="small"
            colorToken="colorIconLowDefault"
            margin-right-small-xx
          />
          <rt-truncate
            [attr.data-cy]="
              'candidate-profile-talent-pools:talent-pool-title:' + placement.talentPool!.id
            "
          >
            {{ placement.talentPool!.title }}
          </rt-truncate>
        </a>
        @if (placement.positiveRatings !== null && placement.ratingVisible) {
          <div layout-horizontal padding-right>
            @if (hasEvaluationImprovements() && evaluationScale(); as scale) {
              <rt-evaluation-rating-score
                [evaluationScale]="scale"
                [averageRatingScorePercent]="placement.positiveRatings!"
                [iconSize]="'small-xx'"
                [fontSize]="'small'"
                [fontWeight]="'default'"
              />
            } @else {
              <rt-interview-evaluation-rating
                [rating]="placement.positiveRatings!"
                [tooltip]="false"
                [size]="'small-xx'"
              />
              <span text-darkest text-small> {{ placement.positiveRatings }}% </span>
            }
          </div>
        }
        @if (talentPoolActions()[placement.id].openMoreDropdown) {
          <rt-icon-button
            #moreDropdownOrigin="rtOverlayOrigin"
            rt-overlay-origin
            iconName="more-horiz"
            shape="square"
            variant="plain"
            size="small"
            [pressed]="moreDropdown.open"
            (click)="moreDropdown.open = !moreDropdown.open"
          />
          <ng-template
            #moreDropdown="rtConnectedOverlay"
            rt-connected-overlay
            hasBackdrop
            [origin]="moreDropdownOrigin"
            (backdropClick)="moreDropdown.open = false"
          >
            <rt-dropdown [width]="DropdownWidth.Medium" (click)="$event.stopPropagation()">
              <rt-dropdown-item
                [routerLink]="'talent_pools/' + placement.talentPool!.slug + '/filters'"
              >
                <rt-icon prefix name="forward" />
                {{ 'app.candidate.go_to_talent_pool_v2' | translate }}
              </rt-dropdown-item>
              <rt-dropdown-item
                (click)="removeFromTalentPool(placement); moreDropdown.toggleOverlay(false)"
              >
                <rt-icon prefix name="remove" />
                {{ 'app.candidate.remove_talent_pool' | translate }}
              </rt-dropdown-item>
            </rt-dropdown>
          </ng-template>
        }
      </div>
      <ng-template #offerTitleTooltipTemplate>
        <rt-candidate-offer-tooltip [placement]="placement" />
      </ng-template>
    }
  </div>
</rt-collapsible-card>
